// Create a [global] array to receive AJAX requests
var ajaxRequests = [];
var emptyArrayChecker = 0;

// Sort the array function - 
// this sorts ascending:  return ((a.priority < b.priority) ? -1 : (a.priority > b.priority) ? 1 : 0);
// this sorts DEscending: return ((b.priority < a.priority) ? -1 : (b.priority > a.priority) ? 1 : 0); 
function sortArrayByPriority(a, b) {
    return ((a.priority < b.priority) ? -1 : (a.priority > b.priority) ? 1 : 0);
};

// Sort array
ajaxRequests.sort(sortArrayByPriority);

// At this point we have a sorted array of the ajax calls 
// Do processing 
function processAjaxRequests(maxNumberToProcess) {
    if (window.log && ajaxRequests.length > 0) {
        window.log("ajaxRequests length: " + ajaxRequests.length);
    }

    // Check size of array & if empty after 30 cycles quit
    if (ajaxRequests.length === 0) {
        emptyArrayChecker++;

        if (emptyArrayChecker >= 30) {
            clearInterval(ajaxProcessor_Interval);
        };

        return;
    }

    // otherwise if max number of requests to process (passed in as a var) is greater than or equal to 
    // the array length, then set it to array length 
    var requestsToProcess = (ajaxRequests.length >= maxNumberToProcess) ? maxNumberToProcess : ajaxRequests.length;

    // Grab items from the array to process
    var workerQueue = ajaxRequests.slice(0, requestsToProcess);

    $.each(workerQueue, function (index) {
        workerQueue[index].funct_to_call();
        // as we go remove elements from the ajaxRequests array
        ajaxRequests.shift();
    });
}

// Repeating call to the function with interval set to 250ms to allow array to load calls initially  
var ajaxProcessor_Interval = setInterval(function () { processAjaxRequests(4); }, 250);
define("app-SearchResults/core/broker", function(){});

